import UploadAdapter from "./upload-adapter"

export default function UploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => new UploadAdapter(editor, loader)
}
